import { Page } from './../../common/types/page.type';
import { Injectable } from '@angular/core';

import { AutoCompleteService, EntityService, HttpClient, PageParameters, SelectItem } from '@elotech/angular-common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TipoRelatorioEnum } from '../../export-report/tipo-relatorio-enum';
import { ConfiguracaoGeralRelatorio, TipoRelatorio } from './model';
import { RelatorioDTO } from '../../common/interface/relatorio-dto';

@Injectable()
export class ConfiguracaoGeralRelatorioService extends EntityService<ConfiguracaoGeralRelatorio> implements AutoCompleteService {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.resource = '/api/configuracao-geral-relatorio';
  }

  objToOption(item: any): string {
    return `${item.label}`;
  }

  objToOptionTipoRelatorio(item: any): string {
    return `${item.descricao}`;
  }

  findToOptions(searchValue: string): Observable<SelectItem[]> {
    return this.findAllByRelatoriosInterno(searchValue).pipe(map(itens => itens.map(item => ({
      label: item.name,
      value: item.id
    }))));
  }

  findOneReport(uuid: string): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/findOne-report/${uuid}`,
      location: this.location
    });
  }

  saveDto(dto: any): Observable<ConfiguracaoGeralRelatorio> {
    return this.httpClient.post({
      resource: `${this.resource}/dto`,
      body: dto
    });
  }

  updateDto(id: number, entity: any, fields?: string): Observable<ConfiguracaoGeralRelatorio> {
    return this.httpClient.put({
      resource: `${this.resource}/dto`,
      body: entity,
      id,
      fields: this.calculeFields(fields),
      location: this.location
    });
  }

  removeDto(id: number) {
    return this.httpClient.del({
      resource: `${this.resource}/dto/${id}`
    });
  }

  findAllDto(search?: string, page?: PageParameters, fields?: string, disableSpinner?: boolean): Observable<Page<ConfiguracaoGeralRelatorio>> {
    return this.httpClient.get({
      resource: `${this.resource}/findAll-dto`,
      page,
      search: search,
      disableSpinner
    });
  }

  findAllReport(search?: string): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/findAll-report`,
      search: search,
      disableSpinner: false
    });
  }

  findAllByRelatoriosInterno(tipoRelatorio: string): Observable<RelatorioDTO[]> {
    return this.httpClient.get({
      resource: `${this.resource}/findBy-relatorio-interno?tipoRelatorio=${tipoRelatorio}`
    });
  }

  getIdRelatorioConfigurado(tipoRelatorio: string): Observable<string> {
    return this.httpClient.get({
      resource: `${this.resource}/getId-relatorio-configuracao?tipoRelatorio=${tipoRelatorio}`
    });
  }

  findAllByExibirPortalServidorIsTrue(servidorId: number): Observable<ConfiguracaoGeralRelatorio[]> {
    return this.httpClient.get({
      resource: `${this.resource}/find-all-relatorios-portal-servidor?servidorId=${servidorId}`,
    });
  }

  existsRelatorioConfiguradoPortalServidor(): Observable<boolean> {
    return this.httpClient.get({
      resource: `${this.resource}/exists-relatorio-portal-servidor`,
    });
  }

  findAllRelatoriosInternos(search: string = ''): Observable<TipoRelatorio[]> {
    return this.httpClient.get({
      resource: `${this.resource}/relatorios-internos`,
      search: search,
      page: new PageParameters(100)
    }).pipe(
      map(page => page.content)
    );
  }

  existsByTipoRelatorio(tipoRelatorio: TipoRelatorioEnum): Observable<boolean> {
    return this.httpClient.get({
      resource: this.resource,
      search: `tipoRelatorio==${tipoRelatorio}`,
      fields: 'id'
    }).pipe(map(ret => !ret.empty));
  }

  registrarEmissaoRelatorio(servidorId: number, configGeralRelId: number): Observable<void> {
    return this.httpClient.post({
      resource: `${this.resource}/registrar-emissao-relatorio?servidorId=${servidorId}&configGeralRelId=${configGeralRelId}`
    });
  }

}
